import { Fragment } from 'react'

// Month × Year heatmap: months down the side, years across the top — so you can
// compare the same month across years. cells = [{ year, month(1-12), value }].
const MONTHS = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
const hexToRgb = (hex) => { const h = hex.replace('#', ''); return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)) }
const fmtFull = (n) => Math.round(Number(n) || 0).toLocaleString('en-US')

export default function HeatmapYM({ cells = [], color = '#2563eb', emptyText = 'ไม่มีข้อมูล' }) {
  const years = [...new Set(cells.map((c) => c.year))].sort((a, b) => b - a)
  if (!years.length) return <div className="flex items-center justify-center text-[13px] text-slate-400 h-[200px]">{emptyText}</div>
  const map = {}
  for (const c of cells) map[`${c.year}-${c.month}`] = c.value
  const max = Math.max(1, ...cells.map((c) => c.value || 0))
  const [r, g, b] = hexToRgb(color)

  return (
    <div className="overflow-x-auto pt-1">
      <div className="grid gap-1 min-w-[420px]" style={{ gridTemplateColumns: `46px repeat(${years.length}, minmax(86px, 1fr))` }}>
        <div />
        {years.map((y) => <div key={y} className="text-center text-[12.5px] font-medium text-slate-500 pb-0.5">{y}</div>)}
        {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
          <Fragment key={m}>
            <div className="flex items-center text-[12px] text-slate-500">{MONTHS[m - 1]}</div>
            {years.map((y) => {
              const v = map[`${y}-${m}`] || 0
              const a = v > 0 ? 0.14 + 0.86 * (v / max) : 0
              return (
                <div key={y} title={`${MONTHS[m - 1]} ${y}: ${fmtFull(v)}`}
                  className="h-9 rounded flex items-center justify-center text-[10.5px] font-semibold tabular-nums"
                  style={{ background: v > 0 ? `rgba(${r},${g},${b},${a})` : '#f1f5f9', color: a > 0.55 ? '#fff' : '#64748b' }}>
                  {v > 0 ? fmtFull(v) : ''}
                </div>
              )
            })}
          </Fragment>
        ))}
      </div>
    </div>
  )
}
